<template>
  <layout-basic>
    <div class="section">
      <b-loading :is-full-page="loader.isFullPage" :active.sync="loader.isLoading" :can-cancel="false"></b-loading>
      <div class="columns">
        <div class="column auto">
          <form
            id="app"
            action="#"
            novalidate
            enctype="multipart/form-data"
            method="post"
            v-on:submit="formSubmit"
          >
              <b-field
                      label="Purchase order name"
                      :type="{'is-danger': errors.has('purchase order name')}"
                      :message="errors.first('purchase order name')"
              >
                  <b-input
                          v-model="model.orderName"
                          name="purchase order name"
                          v-validate="'required'"
                  ></b-input>
              </b-field>

              <b-field
                      label="Contact"
                      :type="{'is-danger': errors.has('contact')}"
                      :message="errors.first('contact')"
              >
                  <b-select
                          placeholder="Select the contact"
                          v-model="model.contact"
                          name="contact"
                          v-validate="'required'"
                          expanded>
                      <option
                              v-for="contact in contacts"
                              :value="contact.id"
                              :key="contact.id">
                          {{ contact.name }}
                      </option>
                  </b-select>
              </b-field>

              <b-field
                      label="Vendor"
                      :type="{'is-danger': errors.has('vendor')}"
                      :message="errors.first('vendor')"
              >
                  <b-select
                          placeholder="Select the vendor"
                          v-model="model.vendor"
                          name="vendor"
                          v-validate="'required'"
                          expanded>
                      <option
                              v-for="vendor in vendors"
                              :value="vendor.id"
                              :key="vendor.id">
                          {{ vendor.name }}
                      </option>
                  </b-select>
              </b-field>

              <b-field
                      label="Shipping level"
                      :type="{'is-danger': errors.has('shipping level')}"
                      :message="errors.first('shipping level')"
              >
                  <b-select
                          placeholder="Select a shipping level"
                          v-model="model.shippingLevel"
                          name="shipping level"
                          v-validate="'required'"
                          expanded
                  >
                      <option
                              v-for="shippingLevel in shippingLevels"
                              :value="shippingLevel"
                              :key="shippingLevel">
                          {{ shippingLevel }}
                      </option>
                  </b-select>
              </b-field>

              <b-field
                      label="Quantity of copies"
                      :type="{'is-danger': errors.has('purchase order quantity')}"
                      :message="errors.first('purchase order quantity')"
              >
                  <b-input
                          type="number"
                          v-model="model.quantity"
                          name="purchase order quantity"
                          v-validate="{required: true, numeric: true, max_value: 999, min_value: 1}"
                  ></b-input>
              </b-field>

              <b-field label="Post order immediately to Cloudprinter.com">
                  <b-checkbox v-model="model.postToCP">Yes</b-checkbox>
              </b-field>

            <template>
              <section class="has-text-right">
                <input type="submit" name="submit" class="button is-info" value="Create Purchase Order">
              </section>
            </template>
          </form>
        </div>
      </div>
    </div>
  </layout-basic>
</template>

<script>

import LayoutBasic from '@/layouts/LayoutBasic'
import axios from 'axios'

export default {
  name: 'OrderCreate',
  components: {
    LayoutBasic
  },
  data () {
    return {
      loader: {
        isFullPage: true,
        isLoading: true,
      },
      model: {
        orderName: 'Order based on product set',
        contact: null,
        shippingLevel: 'Express ground - Tracked',
        postToCP: false,
        productSetId: null
      },
      contacts: [],
      vendors: [],
      shippingLevels: [
        'Express ground - Tracked',
        'Express fast - Tracked',
        'Express saver - Tracked',
        'Postal - Untracked'
      ]
    }
  },

  created () {
    this.loader.isLoading = true;
    ZOHO.embeddedApp.on("PageLoad", (data) => {
      this.resetModel();
      this.model.productSetId = data.EntityId[0];
      this.getContacts();
      this.getVendors();
    });

    ZOHO.embeddedApp.init()
  },

  methods: {
    resetModel: function () {
      this.model.orderName = 'Order based on product set';
      this.model.contact = '';
      this.model.quantity = 1;
      this.model.shippingLevel = 'Express ground - Tracked';
      this.model.postToCP = false;
    },

    getContacts: function () {
      ZOHO.CRM.API.getAllRecords({ Entity: 'Contacts', sort_order: 'asc', per_page: 10000, page: 1 })
        .then((response) => {
          response.data.forEach((contact) => {
            this.contacts.push({
              'id': contact.id,
              'name': contact.Full_Name
            })
          })
        }).catch((err) => {
          console.log(err)
        }).finally(() => {
          this.loader.isLoading = false
        })
    },

    getVendors: function () {
      ZOHO.CRM.API.getAllRecords({ Entity: 'Vendors', sort_order: 'asc', per_page: 10000, page: 1 })
        .then((response) => {
          response.data.forEach((vendor) => {
            if (vendor.Vendor_Name === 'Cloudprinter') {
              this.model.vendor = vendor.id;
            }

            this.vendors.push({
              'id': vendor.id,
              'name': vendor.Vendor_Name
            })
          })
        }).catch((err) => {
          console.log(err)
        }).finally(() => {
          this.loader.isLoading = false
        })
    },

    formSubmit: function (event) {
      event.preventDefault();
      this.$validator.validate()
        .then((result) => {
          if (result) {
            this.loader.isLoading = true;
            const funcName = 'cloudprintercom__createpurchaseorder'
            const reqData = {
              'arguments': JSON.stringify(this.model)
            }

            ZOHO.CRM.FUNCTIONS.execute(funcName, reqData)
              .then((response) => {
                if (response.code == 'success') {
                  this.$toast.open({
                    message: response.details.output,
                    type: 'is-success'
                  });
                  this.resetModel();
                }

              })
              .catch(() => {
                this.$toast.open({
                  message: 'Something went wrong',
                  type: 'is-danger'
                });
              }).finally(() => {
              this.loader.isLoading = false
            })
          }
        })
    }
  }
}
</script>
